export const STATS_DESC = 'STATS_DESC';